import $ from 'jquery';

if ( $( '.c-consent' ).length ) {
	$( document ).on( 'click', '.c-consent .c-button', function() {
		$( this ).closest( '.c-consent' ).fadeOut( 200 );
	} );
}
